import axios from 'axios';

const APIAxios = axios.create({
  baseURL: 'https://shumas-api-gzcvfvgsarhsbxf2.uaenorth-01.azurewebsites.net/api', // Replace this with your API's base URL
  headers: {
    // 'Authorization': 'Bearer your_token_here', // Add your default authorization header if needed
    'Content-Type': 'application/json', // Set the default content type for requests
  },
});

export default APIAxios;